/**
 * @module profile/components/portfolio/portfolio_controls
 */
import React, { Component, PropTypes } from 'react';
import ListControls from 'common/containers/list_controls';
import { getAppliedPortfolioFilters } from 'profile/ducks/portfolio';
import { cleanupFilters } from 'common/utils';

/**
 * Main portfolio view component
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class PortfolioControls extends Component {
  constructor(props) {
    super(props);

    this.applyFilters = this.applyFilters.bind(this);
    this.notifyFilterForms = this.notifyFilterForms.bind(this);
  }

  notifyFilterForms(forms, filter, val) {
    forms.forEach(form => {
      if (document.getElementById(`${filter}^${form}`)) {
        this.props.change(form, `${filter}^${form}`, val);
      }
    });
  }

  applyFilters(data) {
    const filtersData = cleanupFilters(data);

    this.props.savePortfolioFilters(filtersData)
    .then(() => {
      this.props.fetchPortfolioEntries(this.props.profileUsername);
    })
    .catch(() => {
      console.log('Filtering save error');
    });
  }

  render() {
    const { filters, disabled } = this.props;

    return (
      <ListControls
        filters={filters}
        disabled={disabled}
        page="portfolio"
        onNotifyFilterForm={(filter, val) => {
          this.notifyFilterForms(['portfolio_drawer-filtering-form'],
            filter, val);
        }}
        onApplyFilters={this.applyFilters}
        appliedFilteringFn={getAppliedPortfolioFilters}
      />
    );
  }
}

/**
 * PropTypes.
 *
 * @property {string} profileUsername - username of the profile owner
 * @property {array} filters - array of available entries filters
 * @property {bool} disabled - bool value defining if form sholud be disabled
 * @property {func} fetchPortfoliotEntries - function fetching entries from the DB
 * @property {func} savePortfolioFilters - function saving portfolio filters
 * @property {func} change - redux form action creator that fires change
 *                           action on the appropriate form
 */
PortfolioControls.propTypes = {
  profileUsername: PropTypes.string,
  filters: PropTypes.array,
  disabled: PropTypes.bool,
  fetchPortfolioEntries: PropTypes.func,
  savePortfolioFilters: PropTypes.func,
  change: PropTypes.func,
};



// WEBPACK FOOTER //
// ./profile/components/portfolio/portfolio_controls.jsx